export const OUT_OF_PAYROLL_TRANSACTIONS_RESET = 'OUT_OF_PAYROLL_TRANSACTIONS_RESET'

export const OUT_OF_PAYROLL_TRANSACTIONS_LOAD = 'OUT_OF_PAYROLL_TRANSACTIONS_LOAD'
export const OUT_OF_PAYROLL_TRANSACTIONS_LOAD_FULFILLED =
  'OUT_OF_PAYROLL_TRANSACTIONS_LOAD_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTIONS_LOAD_REJECTED = 'OUT_OF_PAYROLL_TRANSACTIONS_LOAD_REJECTED'

export const OUT_OF_PAYROLL_TRANSACTION_LOAD = 'OUT_OF_PAYROLL_TRANSACTION_LOAD'
export const OUT_OF_PAYROLL_TRANSACTION_LOAD_FULFILLED = 'OUT_OF_PAYROLL_TRANSACTION_LOAD_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTION_LOAD_REJECTED = 'OUT_OF_PAYROLL_TRANSACTION_LOAD_REJECTED'

export const OUT_OF_PAYROLL_TRANSACTION_CREATE = 'OUT_OF_PAYROLL_TRANSACTION_CREATE'
export const OUT_OF_PAYROLL_TRANSACTION_CREATE_PENDING = 'OUT_OF_PAYROLL_TRANSACTION_CREATE_PENDING'
export const OUT_OF_PAYROLL_TRANSACTION_CREATE_FULFILLED =
  'OUT_OF_PAYROLL_TRANSACTION_CREATE_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTION_CREATE_REJECTED =
  'OUT_OF_PAYROLL_TRANSACTION_CREATE_REJECTED'

export const OUT_OF_PAYROLL_TRANSACTION_UPDATE = 'OUT_OF_PAYROLL_TRANSACTION_UPDATE'
export const OUT_OF_PAYROLL_TRANSACTION_UPDATE_PENDING = 'OUT_OF_PAYROLL_TRANSACTION_UPDATE_PENDING'
export const OUT_OF_PAYROLL_TRANSACTION_UPDATE_FULFILLED =
  'OUT_OF_PAYROLL_TRANSACTION_UPDATE_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTION_UPDATE_REJECTED =
  'OUT_OF_PAYROLL_TRANSACTION_UPDATE_REJECTED'

export const OUT_OF_PAYROLL_TRANSACTION_DELETE = 'OUT_OF_PAYROLL_TRANSACTION_DELETE'
export const OUT_OF_PAYROLL_TRANSACTION_DELETE_FULFILLED =
  'OUT_OF_PAYROLL_TRANSACTION_DELETE_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTION_DELETE_REJECTED =
  'OUT_OF_PAYROLL_TRANSACTION_DELETE_REJECTED'

// Attachment
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_LOAD =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_LOAD'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_LOAD_FULFILLED =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_LOAD_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_LOAD_REJECTED =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_LOAD_REJECTED'

export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_CREATE =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_CREATE'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_CREATE_PENDING =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_CREATE_PENDING'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_CREATE_FULFILLED =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_CREATE_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_CREATE_REJECTED =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_CREATE_REJECTED'

export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_UPDATE =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_UPDATE'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_UPDATE_PENDING =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_UPDATE_PENDING'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_UPDATE_FULFILLED =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_UPDATE_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_UPDATE_REJECTED =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_UPDATE_REJECTED'

export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_DELETE =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_DELETE'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_DELETE_FULFILLED =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_DELETE_FULFILLED'
export const OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_DELETE_REJECTED =
  'OUT_OF_PAYROLL_TRANSACTION_ATTACHMENTS_DELETE_REJECTED'
